import React from "react";
import { CalendarClock, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSchedule } from "@/lib/useSchedule";
import { hhmm, dayNames } from "@/lib/schedule";
import { AV } from "@/pages/availabilityText";

export function AvailabilityBar() {
  const { lang } = useLang();
  const x = AV[lang] || AV.en;
  const s = useSchedule();
  const days = dayNames(lang);
  const status = s.current.length
    ? `${x.onDuty}: ${s.current.map((e) => e.name).join(", ")}`
    : s.next ? `${x.nextShift}: ${days[s.next.day]} ${hhmm(s.next.start)}` : x.none;
  return (
    <a href="/availability" data-testid="availability-bar"
      className="group mb-4 flex items-center gap-4 rounded-xl border border-blue-500/25 bg-[#0b1430] px-5 py-4 transition-colors hover:border-blue-400/50">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-[#003399] text-[#FFCC00]"><CalendarClock size={18} /></div>
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-semibold text-zinc-50">{x.check}</div>
        <div className="truncate text-[12px] text-zinc-400">
          <span className={`mr-1.5 inline-block h-1.5 w-1.5 rounded-full align-middle ${s.current.length ? "bg-emerald-400" : "bg-zinc-600"}`} />
          <span data-testid="availability-bar-status">{s.loaded ? status : "…"}</span>
        </div>
      </div>
      <ArrowRight size={16} className="text-blue-300 transition-transform group-hover:translate-x-0.5" />
    </a>
  );
}
